// extracted by mini-css-extract-plugin
module.exports = {"accordion__arrow":"styles-module--accordion__arrow--33VxI","accordion__details":"styles-module--accordion__details--1pAf7"};